












import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import AdminDepositBankAccountUpdateForm
  from '@/modules/deposit-bank-account/components/admin/forms/AdminDepositBankAccountUpdateForm.vue'
import { Prop } from 'vue-property-decorator'
import {
  DepositBankAccountResourceType
} from '@/modules/deposit-bank-account/models/deposit-bank-account-resource.model'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'حساب بانکی شرکت'
  },
  metaInfo: {
    title: 'حساب بانکی شرکت'
  },
  components: {
    AdminDepositBankAccountUpdateForm
  }
})
export default class AdminDepositBankAccountShowPage extends Vue {
  @Prop() account: DepositBankAccountResourceType
}
